"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _commonReact = require("@devsta/common-react");

var _SortableClips = _interopRequireDefault(require("../components/SortableClips"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DRAG_TYPE = 'box';

function drop(_ref, monitor) {
  var onClipDrop = _ref.onClipDrop;

  var _monitor$getSourceCli = monitor.getSourceClientOffset(),
      x = _monitor$getSourceCli.x,
      y = _monitor$getSourceCli.y;

  return {
    onClipDrop: onClipDrop,
    xPos: x,
    yPos: y
  };
}

var dragHandlers = {
  drop: drop
};

function getDragConfig(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

function SortableClips(props) {
  return /*#__PURE__*/_react.default.createElement(_commonReact.CommentsConsumer, null, function (_ref2) {
    var _ref2$actions = _ref2.actions,
        getOrderedComments = _ref2$actions.getOrderedComments,
        deleteComment = _ref2$actions.deleteComment;
    return /*#__PURE__*/_react.default.createElement(_SortableClips.default, _extends({}, props, {
      comments: getOrderedComments(),
      deleteComment: deleteComment
    }));
  });
}

var _default = (0, _reactDnd.DropTarget)(DRAG_TYPE, dragHandlers, getDragConfig)(SortableClips);

exports.default = _default;